module.exports = __webpack_public_path__ + "img/Motor_mob_5.e4099570.jpg";